export function downloadBase64Image(base64String: string, fileName: string) {
  // Create an anchor element
  const a = document.createElement('a');

  // Set the href to the base64 string
  a.href = base64String; // You may need to change the content type based on the image format

  // Set the download attribute to specify the file name
  a.download = fileName;

  // Trigger a click event on the anchor element
  a.click();

  // Clean up by removing the anchor element
  a.remove();
}
